export default __webpack_public_path__ + "static/media/01.ba9c0ae4.jpg";